export default {
    appTitle: "Kunniakierros",
    common: {
        next: "Seuraava",
        ok: "OK",
    },
    user: {
        username: "Sähköposti",
        pin: "PIN-koodi",
        password: "Salasana",
    },
    loginView: {
        title: "Pyydä pin-koodi",
        login: "Kirjaudu sisään",
        enterUsername: "Kirjoita käyttäjätunnuksesi.",
        nonexistentUser: "Käyttäjätunnusta ei löydy. Tarkista käyttäjätunnus.",
        enterPinHelp: "Kirjoita PIN-koodi jonka sait sähköpostitse.",
        enterPin: "Kirjoita PIN-koodisi.",
        sendPinTitle: "Eikö PIN-koodia löydy?",
        sendPinHelp: "Etkö saanut PIN-koodia sähköpostiisi? Tarkasta vielä roskapostisi tai pyydä uusi PIN-koodi.",
        sendPin: "Tilaa uusi PIN-koodi",
        pinInvalid: "PIN-koodi on virheellinen.",
        pinSentTopic: "PIN lähetetty",
        pinSent: "Lähetimme sähköpostiisi uuden PIN-koodin. Tarkista sähköpostisi hetken kuluttua ja kirjoita PIN-koodi. Samalla vanha PIN-koodisi vanhentui, joten varmista että katsot uusinta viestiä.",
        askForPin: "Pyydä pin-koodi",
        requestingPin: "Pyydetään pin-koodia...",
        pinRequestFailed: "Pin-koodin haku epäonnistui. Varmista, että internet-yhteytesi on päällä.",
        cookieInfo: "Sovellus hyödyntää evästeitä mm. käytön helpottamiseksi ja tietoturvan edistämiseksi. Evästeiden antamien tietojen avulla myös kehitämme palvelua ja käyttökokemusta. Lue lisää yksityisyysasetuksista.",
        authErrorTitle: "Virhe kirjautumisessa",
        authErrorDescription: "Vanhentuneet kirjautumistiedot poistettiin. Kirjaudu sisään uudelleen.",
    },
    homeView: {
        title: "Etusivu",
        infoTitle: "Kunniakierros",
        perLap: " / kierros",
        totalSponsorPayments: "ja mahdollisuus kerätä seuralle",
        sponsorsParticipating: "Sinulla on nyt {0} tukijaa",
        inviteSponsor: "Kutsu tukijoita",
        // instructions: "Ohjeet",
        instructions: "Keräyssäännöt",
        sponsors: "Tukijat",
        selectOrganization: "Valitse seura",
        selectEvent: "Valitse keräys",
        // event: "Keräys",
        event: "Kunniakierrokseni",
        eventInfo: "Seura & keräyskampanja",
        permit: "Keräyslupa",
        logout: "Kirjaudu ulos",
        goal: "Tavoite:",
        repeats: "Aseta kierrokset",
        noGoal: "Ei tavoitetta",
        repeatsButton: "Kierrokset",
        noOrganization: "Sinua ei ole liitetty yhteenkään seuraan. Ota yhteyttä oman seurasi vastuuhenkilöön.",
        noEvent: "Sinua ei ole liitetty yhteenkään keräykseen. Omat keräykset näkyvät tässä, kun seuran vastuuhenkilö on lisännyt sinut osallistujaksi keräykseen.",
        addOrInviteSponsors: "Lisää tai kutsu tukijoita!",
        billingInfo: "Nyt on mahdollista laskuttaa tukijoita suoraan sovelluksen kautta! Laskutus tapahtuu Tukijat-näkymässä. Ota yhteyttä seurasi yhteyshenkilöön, jos haluat ottaa laskutuksen käyttöön.",
    },
    myProfileView: {
        title: "Asetukset",
        logout: "Kirjaudu ulos",
        saveChanges: "Tallenna muutokset",
        slogan: "Oma kutsuviestini",
        account: "Tili",
        profilePicture: "Profiilikuva",
        myProfilePicture: "Profiilikuvani",
        chooseProfilePicture: "Valitse profiilikuva",
        allowedImageTypes: "Sallitut tiedostotyypit: JPG, PNG",
        instructions: "Ohjeet",
        language: "Kieli",
        locale_fi: "suomi",
        locale_se: "ruotsi",
        changesSaved: "Tiedot tallennettu",
        choosePictureAndText: "Valitse kutsussa käytettävä profiilikuva ja kirjoita haluamasi viesti tukijoille",
        privacySettings: "Yksityisyysasetukset",
    },
    privacySettingsView: {
        title: "Yksityisyysasetukset",
        content: "",
        moreInfo: "Lisätietoja: {email} tai rekisteriselosteesta {privacyPolicyUrl}",
    },
    sponsorsView: {
        title: "Tukijat",
        sponsors: "Tukijat",
        participatingSponsors: "Mukaan lähteneet tukijat",
        paymentComplete: "Maksu suoritettu",
        sendReminder: "Muistuta maksusta",
        billSent: "Lasku lähetetty {0}",
        reminderSent: "Muistutus lähetetty {0}",
        paymentCompleted: "Maksu suoritettu",
        inviteSponsor: "Kutsu tukija",
        addSponsor: "Lisää uusi tukija",
        paymentPerRepeat: "Tukisumma {0} €/krs",
        maxPayment: "maks. {0} €",
        paymentManual: "Tukisumma {0} €",
        sendBill: "Lähetä lasku",
        sentInvitations: "Lähetetyt kutsut",
        invitedOn: "Kutsuttu {0}",
        sendInvitation: "Lähetä kutsu",
        inviteAgain: "Kutsu uudelleen",
        maxPaymentSum: "Maksimisumma",
        notParticipating: "Kieltäytyneet",
        noInvitations: "Ei lähetettyjä kutsuja",
    },
    startView: {
        title: "",
        signUp: "Ilmoittaudu mukaan",
        login: "Kirjaudu sisään",
        about: "Tutustu",
        footerText: "2018 © Suomen Urheiluliitto ry",
    },
    inviteSponsorView: {
        title: "Kutsu tukijoita",
        sendInvitation: "Lähetä kutsu",
        sendInvitations: "Lähetä kutsut",
        sendingInvitations: "Lähetetään kutsuja",
        inFacebook: "Facebookissa",
        viaEmail: "Sähköpostilla",
        writeEmailAddress: "Kirjoita sähköpostiosoite",
        send: "Lähetä",
        emailInvitationSent: "Kutsu lähetetty",
        emailInvitationsSent: "Kutsut lähetetty",
        emailInvitationFailed: "Kutsun lähetys epäonnistui",
        duplicateSponsor: "Tämä tukija on jo listallasi. Jos tämä tukija ei ole vastannut kutsuun, voit lähettää uuden kutsun tukijat-sivun kautta.",
        invitePreviousSponsors: "Kutsu edelliskertojen tukijoita",
        addRecipient: "Lisää vastaanottaja",
        copySponsorLink: "Kopioi kutsulinkki",
        copied: "Kopioitu",
    },
    addSponsorView: {
        title: "Lisää uusi tukija",
        fillSponsorInformation: "Anna tukijan tiedot",
        //name: "Nimi",
        firstname: "Etunimi",
        lastname: "Sukunimi",
        email: "Sähköpostiosoite",
        paymentAmount: "Tukisumma (min. {0}€)",
        paymentPerRepeat: "Kierrosmaksu",
        oneTimePayment: "Kertamaksu",
        // maxPayment: "Maksimisumma",
        suggestedTarget: "Toive tukikohteesta",
        saveSponsor: "Tallenna tiedot",
        sponsorAdded: "Tukija lisätty",
        company: "Yritys",
        companyName: "Yrityksen nimi",
        private: "Yksityinen",
        streetAddress: "Osoite",
        zipCode: "Postinumero",
        city: "Kaupunki",
        info: "Lisätiedot",
        paymentMethodMail: "Posti",
        paymentMethodEmail: "Sähköposti",
        paymentMethodEInvoice: "Verkkolasku",
        bank: "Pankki",
        eInvoicePaymentAddress: "Verkkolaskutusosoite",
    },
    invitePreviousSponsorsView: {
        //inviteSelected: "Lähetä kutsu valituille tukijoille",
        inviteSelected: "Lähetä sähköpostikutsu",
        selectAll: "Valitse kaikki",
        sendingInvitations: "Lähetetään kutsuja",
        invitationsSent: "Kutsut lähetetty",
        noSponsors: "Sinulla ei ole aiempia tukijoita",
        setEmail: "Aseta sähköpostiosoite",
        infoPopupTitle: "Tukijakutsun lähetys",
        infoPopupText: "Jos tukijallasi ei ole sähköpostiosoitetta, hänelle ei voi lähettää kutsua. Vaihtoehtoisesti voit joko lisätä hänet suoraan tukijaksi Lisää uusi tukija -lomakkeella tai ilmoittaa tukijan tiedot seurasi yhteyshenkilölle.",
        goToContacts: "Yhteyshenkilöt",
        chooseSponsors: "Valitse kutsuttavat tukijat",
        invitingSponsorsTo: "Olet kutsumassa tukijoita seuran {0} keräykseen {1}.",
        sponsorsFrom: "Aiemmat tukijat seuran {0} keräyksistä",
    },
    chooseOrganizationView: {
        title: "Valitse seura",
        noEvents: "Sinua ei ole liitetty tässä seurassa yhteenkään keräykseen.",
    },
    chooseEventView: {
        title: "Valitse tapahtuma",
    },
    statisticsView: {
        title: "Tilastot",
        userStatistics: "Minä",
        eventStatistics: "Keräys Top {0}",
        organizationStatistics: "Seura",
        topEventParticipants: "Kerääjät Top {0}",
        allStatistics: "Seurat Top {0}",
        moreStatistics: "Lisää tilastoja",
    },
    userStatisticsView: {
        title: "Saavutukseni",
        events: "Keräykset",
        event: "Tapahtuma",
        paidSum: "Maksettu €",
        estimated: "Kerätty €",
    },
    eventStatisticsView: {
        topParticipants: "{0} top {1}",
    },
    organizationStatisticsView: {
        events: "Keräykset",
    },
    allStatisticsView: {
        numberOfParticipants: "Kerääjiä",
        topOrganizations: "Kunniakierros-seurat top {0}",
        raisedSum: "Kerätty summa",
    },
    editRepeatsView: {
        title: "Kierrokset",
        setEstimatedLaps: "Aseta kierrostavoite",
        repeats: "Toteutunut kierrosmäärä",
        save: "Tallenna",
    },
    eventParticipantTopList: {
        topParticipants: "Tapahtuman parhaat kerääjät",
    },
    topEventParticipantsView: {
        topParticipants: "Kerääjät top {0}",
    },
    permissionView: {
        backToHome: "Takaisin etusivulle",
    },
    mobileAppInstructionsView: {
        title: "Mobiilisovelluksen ohjeet",
    },
};



//////////////////
// WEBPACK FOOTER
// ./app/ts/i18n/fi.ts
// module id = 76
// module chunks = 0